import * as React from 'react';

import PropTypes from 'prop-types';
import { Alert, AlertTitle} from '@material-ui/lab';
import { trackEvent } from '../analytics/tracking';
import closeX from '../../assets/closeX.png';
import styles from './DisplayError.module.css';

const DisplayError = ({ errorContext, errorId, errorText, closeFn}) => {
  
  // Log the error
  React.useEffect(() => {
    trackEvent('error', errorContext, errorId, [{'msg' : errorText}]);
  }, [errorContext, errorId, errorText]);

  return (
    <>
      <div className={styles.modalContent}>
        <img alt="" className={styles.closeIcon} src={closeX} height="24" onClick={closeFn} />
        <Alert severity="error" classes={{ root: `${styles.alertStyle}` }}>
          <AlertTitle>Error</AlertTitle>
          {errorText}
        </Alert>
      </div>  
      <div className={styles.modalBGElem}></div>
    </> 
  );
};

DisplayError.propTypes = {
  errorContext: PropTypes.string,
  errorId:  PropTypes.string,
  errorText:  PropTypes.string,
  closeFn: PropTypes.func
};

export default DisplayError;